module.exports = __webpack_public_path__ + "img/contanctOne.4253e110.png";